import { useEffect, useState } from "react";
import { db } from "../services/firebase";
import { ref, onValue, off } from "firebase/database";

/**
 * Custom hook to fetch all domains from Firebase Realtime Database
 * and keep them updated in real time.
 */
export default function useFetchDomains() {
    const [domains, setDomains] = useState([]);
    const [loadingDomainList, setLoading] = useState(true);

    useEffect(() => {
        const domainsRef = ref(db, "Domains");

        const unsubscribe = onValue(domainsRef, (snapshot) => {
            const data = snapshot.val();

            if (data) {
                // Convert { id: {name, order, ...}, ... } into an array
                const domainArray = Object.entries(data).map(([id, value]) => ({
                    id,
                    ...value,
                }));

                // Sort by order field if available
                domainArray.sort((a, b) => (a.order || 0) - (b.order || 0));

                setDomains(domainArray);
            } else {
                setDomains([]);
            }

            setLoading(false);
        });

        // Clean up listener when unmounted
        return () => {
            off(domainsRef); // remove Firebase listener safely
            unsubscribe();
        };
    }, []);

    return { domains, loadingDomainList };
}
